import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 44 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ index, label }) => (
  <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-light">
    [ {index} ] <span className="text-neutral-500">/ {label}</span>
  </p>
);
